export const KEY_STATE_API_CREATEATTACHMENT = ts_temp__keys.KEY_STATE_API_CREATEATTACHMENT;
export const KEY_STATE_API_DELETEATTACHMENT = ts_temp__keys.KEY_STATE_API_DELETEATTACHMENT;
export const KEY_STATE_ADD_WORKORDER = ts_temp__keys.STATE_CREATING_WORKORDER;
export const KEY_STATE_ADD_ASSET = ts_temp__keys.STATE_CREATING_ASSET;
export const KEY_STATE_ADD_FINDING = ts_temp__keys.STATE_CREATING_FINDING;
export const KEY_STATE_UI_CREATEATTACHMENT_GET_FILE = ts_temp__keys.KEY_STATE_UI_CREATEATTACHMENT_GET_FILE;
export const KEY_STATE_UI_CREATEATTACHMENT_GET_LINK = ts_temp__keys.KEY_STATE_UI_CREATEATTACHMENT_GET_LINK;
export const KEY_STATE_UI_CREATEATTACHMENT_GET_COORD = ts_temp__keys.KEY_STATE_UI_CREATEATTACHMENT_GET_COORD;
export const KEY_STATE_CREATING_ATTACHMENT = ts_temp__keys.STATE_CREATING_ATTACHMENT;
export const KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP = ts_temp__keys.KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP;
export const KEY_STATE_SITEMAP_AVAILABLE = ts_temp__keys.KEY_STATE_SITEMAP_AVAILABLE;
export const KEY_STATE_API_UPDATEATTACHMENT = ts_temp__keys.KEY_STATE_API_UPDATEATTACHMENT;
export const ACTION_SET_DRAWINGS_INFO_DATA = "ACTION_SET_DRAWINGS_INFO_DATA";
// Poor man's implementation of redux
import { buildnum } from './buildinfo';
import Immutable from 'immutable';
import { did_any_value_change, didValueChange, did_value_change } from './utils';

// ACTIONS
export const ACTION_SET_SITEMAP_DATA = "ACTION_SET_SITEMAP_DATA";
export const ACTION_SET_FLOORPLAN_DATA = "ACTION_SET_FLOORPLAN_DATA";
export const ACTION_CLEAR_ASSETS_DATA = "ACTION_CLEAR_ASSETS_DATA";
// ASYNC API Actions
export const ACTION_ADD_FETCHED_ASSETS_FLOOR = "ACTION_ADD_FETCHED_ASSETS_FLOOR";
export const ACTION_ADD_FETCHED_ATTACHMENTS_FLOOR = "ACTION_ADD_FETCHED_ATTACHMENTS_FLOOR";
export const ACTION_SET_ADD_ATTACHMENT_OBJECT = "ACTION_SET_ADD_ATTACHMENT_OBJECT";
export const ACTION_SET_ADD_ATTACHMENT_STATE = "ACTION_SET_ADD_ATTACHMENT_STATE";
export const ACTION_API_CREATEATTACHMENT_FAIL = "ACTION_API_CREATEATTACHMENT_FAIL";
export const ACTION_API_CREATEATTACHMENT_SUCCESS = "ACTION_API_CREATEATTACHMENT_SUCCESS";
export const ACTION_API_CREATEATTACHMENT_START = "ACTION_API_CREATEATTACHMENT_START";
export const ACTION_SET_MENU_ASSETS_SELECTED = "ACTION_SET_MENU_ASSETS_SELECTED";
export const ACTION_SET_MENU_PUSHPIN_SELECTED = "ACTION_SET_MENU_PUSHPIN_SELECTED";
export const ACTION_SET_ID_BUILDING = "ACTION_SET_ID_BUILDING";
export const ACTION_SET_SYSTEM_VARIABLES = "ACTION_SET_SYSTEM_VARIABLES";
export const ACTION_SET_FETCHING_ASSETS = "ACTION_SET_FETCHING_ASSETS";
export const ACTION_SET_FETCHING_ATTACHMENTS = "ACTION_SET_FETCHING_ATTACHMENTS";
export const ACTION_SET_FETCHING_BUILDINGS = "ACTION_SET_FETCHING_BUILDINGS";
export const ACTION_SET_FETCHING_CATEGORIES = "ACTION_SET_FETCHING_CATEGORIES";
export const ACTION_SET_FETCHING_FLOORPLANS = "ACTION_SET_FETCHING_FLOORPLANS";
export const ACTION_SET_FETCHING_SITEMAP_DATA = "ACTION_SET_FETCHING_SITEMAP_DATA";
export const ACTION_SET_FETCHING_DRAWINGS_INFO = "ACTION_SET_FETCHING_DRAWINGS_INFO";
export const ACTION_SET_FETCHING_WORKORDERS = "ACTION_SET_FETCHING_WORKORDERS";
export const ACTION_SET_HARD_CODED_MAP = "ACTION_SET_HARD_CODED_MAP";
export const ACTION_SET_HARD_CODED_MAP_URL = "ACTION_SET_HARD_CODED_MAP_URL";
export const ACTION_SET_ADD_ASSET_STATE = "ACTION_SET_ADD_ASSET_STATE";
export const ACTION_SET_ADD_WORKORDER_STATE = "ACTION_SET_ADD_WORKORDER_STATE";
export const ACTION_TOGGLE_DEBUG = "ACTION_TOGGLE_DEBUG";
export const ACTION_UI_CREATEATTACHMENT_GET_COORD_START = "ACTION_UI_CREATEATTACHMENT_GET_COORD_START";
export const ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP = "ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP";
export const ACTION_SET_PUSHPIN_GET_COORD_START = "ACTION_SET_PUSHPIN_GET_COORD_START";
export const ACTION_SET_PUSHPIN_GET_COORD_STOP = "ACTION_SET_PUSHPIN_GET_COORD_STOP";
export const ACTION_SET_SITEMAP_URL = "ACTION_SET_SITEMAP_URL";
export const ACTION_SET_SITEMAP_AVAILABLE = "ACTION_SET_SITEMAP_AVAILABLE";
export const ACTION_SET_SITEMAP_GEOJSON = "ACTION_SET_SITEMAP_GEOJSON";
export const ACTION_SET_SITEMAP_ID_BUILDING = "ACTION_SET_SITEMAP_ID_BUILDING";

export const KEY_DATA_ASSETS = "data_assets";
export const KEY_DATA_FLOOR_ATTACHMENTS = "data_floor_attachments";
export const KEY_DATA_FLOORPLANS = "data_floorplans";
export const KEY_DATA_ALL_ATTACHMENTS = "data_all_attachments";
export const KEY_DATA_PUSHPIN_COORDS = "data_pushpin_coords";
export const KEY_DATA_SITEMAP = "data_sitemap";
export const KEY_DATA_DRAWING_LOCATION_MAP = "data_drawing_location_map"; // lookup table mapping drawing_ids to id_locations and vice versa
export const KEY_DATA_BUILDINGS = "data_buildings";
export const KEY_DATA_CATEGORIES = "data_categories";
export const KEY_DATA_WORKORDERS = "data_workorders";

var __datastore = {
    state: null,
    immstate: getInitialState(),
    previous_state: Immutable.fromJS({}),
    listeners: []
}

// ...existing code...
export const ACTION_CLEAR_ATTACHMENTS_DATA = ts_temp__actions.ACTION_CLEAR_ATTACHMENTS_DATA;
export const ACTION_CLEAR_FINDINGS_DATA = ts_temp__actions.ACTION_CLEAR_FINDINGS_DATA;
export const ACTION_CLEAR_WORKORDERS_DATA = ts_temp__actions.ACTION_CLEAR_WORKORDERS_DATA;
export const KEY_WORKORDERS_QUERY = "workorders_query"
export const KEY_DEBUG_ENABLED = ts_temp__keys.DEBUG_ENABLED
export const KEY_DOWNLOADED_ATTACHMENT_FLOORS = ts_temp__keys.KEY_DOWNLOADED_ATTACHMENT_FLOORS
export const KEY_DOWNLOADED_ASSET_FLOORS = "downloaded_asset_floors"
const KEY_DOWNLOADED_FINDING_FLOORS = ts_temp__keys.KEY_DOWNLOADED_FINDING_FLOORS;
export const KEY_DRAWING_P1P2 = "drawing_p1p2"
const KEY_BUILDING_P1P2 = ts_temp__keys.KEY_BUILDING_P1P2;
const KEY_DRAWING_P0 = "drawing_p0"
const KEY_FLOOR_DRAWING_HISTORY = "floor_drawing_history";
// const KEY_FLOOR_HISTORY = "floor_history";
const KEY_HARD_CODED_MAP = "hard_coded_map";
const KEY_HARD_CODED_MAP_URL = "hard_coded_map_url";
const KEY_INITIAL_ID_FLOOR = "initial_id_floor";
const KEY_INITIAL_ID_BUILDING = "initial_id_building";
const KEY_P1P2 = "p1p2"
const KEY_P1 = "p1"
const KEY_P2 = "p2"
const KEY_P0 = "p0"
export const KEY_ID_BUILDING = "id_building"
//const KEY_ID_BUILDING             = "building_id_location"
export const KEY_ID_DRAWING = "id_drawing"
export const KEY_ID_FLOOR = "id_floor";
export const KEY_MENU_ATTACHMENTS_CONTENT = ts_temp__keys.KEY_MENU_ATTACHMENTS_CONTENT;
export const KEY_MENU_ATTACHMENTS_SELECTED = ts_temp__keys.KEY_MENU_ATTACHMENTS_SELECTED;
export const KEY_MENU_ASSETS_CONTENT = "menu_assets_content"
export const KEY_MENU_ASSETS_EXPANDED = ts_temp__keys.MENU_ASSETS_EXPANDED;
export const KEY_MENU_ASSETS_SELECTED = ts_temp__keys.MENU_ASSETS_SELECTED;
export const KEY_MENU_PUSHPIN_SELECTED = ts_temp__keys.KEY_MENU_PUSHPIN_SELECTED;
export const KEY_MENU_BUILDINGS_CONTENT = "menu_buildings_content"
export const KEY_MENU_BUILDINGS_SHOW = "menu_buildings_show";
//export const KEY_MENU_FLOORPLANS_CONTENT = ts_temp__keys.KEY_MENU_FLOORPLANS_CONTENT
export const KEY_MENU_WORKORDERS_CONTENT = "menu_workorders_content"
export const KEY_MENU_WORKORDERS_SELECTED = "menu_workorders_selected"
export const KEY_MENU_WORKORDERS_EXPANDED = ts_temp__keys.MENU_WORKORDERS_EXPANDED
const KEY_SITEMAP_GEOJSON = "sitemap_geojson"
const KEY_SITEMAP_ID_BUILDING = "sitemap_id_building"
const KEY_STATE_FIRST_RUN = ts_temp__keys.KEY_STATE_FIRST_RUN;
const KEY_STATE_FETCHING_ASSETS = "fetching_assets";
const KEY_STATE_FETCHING_ATTACHMENTS = "fetching_attachments";
const KEY_STATE_FETCHING_BUILDINGS = "fetching_buildings";
const KEY_STATE_FETCHING_CATEGORIES = "fetching_categories";
const KEY_STATE_FETCHING_FLOORPLANS = "fetching_floorplans";
const KEY_STATE_FETCHING_FINDINGS = ts_temp__keys.STATE_FETCHING_FINDINGS;
const KEY_STATE_PRINTING_FINDINGS = ts_temp__keys.KEY_STATE_PRINTING_FINDINGS;
const KEY_STATE_FETCHING_WORKORDERS = "fetching_workorders";
const KEY_STATE_FETCHING_SITEMAP_DATA = "fetching_sitemap_data";
const KEY_STATE_FETCHING_DRAWINGS_INFO = "fetching_drawings_info";
export const KEY_MOUSE_CURSOR = ts_temp__keys.KEY_MOUSE_CURSOR;
const KEY_BUILDING_WO_COUNT = ts_temp__keys.KEY_BUILDING_WO_COUNT;

// Add Attachment
export const KEY_ADD_ATTACHMENT_OBJECT = ts_temp__keys.KEY_ADD_ATTACHMENT_OBJECT;
export const VALUE_CREATING_ATTACHMENT_VOID = ts_temp__state_values.STATE_CREATING_ATTACHMENT;
export const VALUE_CREATING_ATTACHMENT_GETTING_COORD = ts_temp__state_values.STATE_CREATING_ATTACHMENT_GETTING_COORD;
export const VALUE_CREATING_ATTACHMENT_GETTING_FILE = ts_temp__state_values.STATE_CREATING_ATTACHMENT_GETTING_FILE;
export const VALUE_CREATING_ATTACHMENT_GETTING_URL = ts_temp__state_values.STATE_CREATING_ATTACHMENT_GETTING_URL;
export const VALUE_CREATING_ATTACHMENT_SAVING_FILE = ts_temp__state_values.STATE_CREATING_ATTACHMENT_SAVING_FILE;
export const VALUE_CREATING_ATTACHMENT_API_BUSY = ts_temp__state_values.STATE_CREATING_ATTACHMENT_API_BUSY;
const KEY_ATTACHMENT_TYPE = ts_temp__keys.ATTACHMENT_TYPE;


let __raw_floorplans = {};
let __raw_assets = {};
export { __raw_floorplans };
let __sorted_raw_assets = {};  // {id_asset:{raw asset}, ...}
let __sorted_raw_assets_new = {};  // {id_floor:{id_asset:{asset}, ... }, ...}
let __raw_workorders = {};
let __sorted_raw_workorders = {};

/**
 * __clean_raw_floorplan_data()
 * @param {floorplan_data}   The raw output of /api/DrawingLocations/F and cleans it up.
 * @return {immutable array of floorplans} cleaned up floorplan data
 1. cleans up the names (idParent -> id_building, etc.)
 2. fills in any missing data
 3. reports errors
 */
function __clean_raw_floorplan_data(floorplan_data) {
    return Immutable.fromJS(ts_temp__clean_raw_floorplan_data(floorplan_data))
}


function __cookies_get(key, default_value) {
    return ts_temp__cookeies_read(key, default_value)
    // if (default_value === undefined) {
    //     default_value = null
    // }
    // r = Cookies.get(key)
    // if (r === undefined) {
    //     return default_value
    // }
    // if (r === null) {
    //     return default_value
    // }
    // return r
}

function __cookies_get_int(key, default_value) {
    var r = parseInt(__cookies_get(key, default_value))
    if (isNaN(r)) {
        r = default_value
    }
    return r
}

function __cookies_get_bool(key, default_value) {
    val = __cookies_get(key, default_value)

    if (typeof val === 'undefined') {
        return false
    }

    if (typeof val === 'boolean') {
        if (val === true) {
            return true
        }
        return false
    }

    if (val === null) {
        return false
    }

    if (val === 1) {
        return true
    }

    if (typeof val === 'string') {
        if (val.toLowerCase() === "true") {
            return true
        }
    }
    return false
}
function __cookies_get_json(key, default_value) {
    if (default_value === undefined) {
        default_value = null;
    }
    let r = __cookies_get(key);
    if (r === undefined) {
        return default_value;
    }
    if (r === null) {
        return default_value;
    }
    try {
        return JSON.parse(r);
    } catch (e) {
        console.error(e);
        return default_value;
    }

}
function __cookies_set_json(key, value) {
    //   Cookies.set(key, JSON.stringify(value))
    __cookies_set_string(key, JSON.stringify(value))
}
function __cookies_set_bool(key, value) {
    //    Cookies.set(key, value == true)
    __cookies_set_string(key, value == true)
}

function __cookies_set_string(key, value) {
    //    Cookies.set(key, value)
    return ts_temp__cookeies_write(key, value)
}

function __cookies_set_int(key, value) {
    if (typeof (123) !== typeof (value)) {
        value = parseInt(value)
    }
    //    Cookies.set(key, value)
    __cookies_set_string(key, value)
}

function __generate_hash() {
    return moment().valueOf()
}

/**
 * Searches floorplan data that comes back from API call
 * for a certain floor in a building.
 * returns true if it finds the floor in the building
 * @param id_floor
 * @param id_building
 * @param imm_state
 * @return {boolean}
 * @private
 */
function __isFloorInBuilding(id_floor, id_building, imm_state) {
    // AWH this should have moved to TS
    // return ts_temp__isFloorInBuilding(id_floor, id_building, imm_state)
    retval = false
    var floorplans = getJSArray(imm_state, KEY_DATA_FLOORPLANS, [])
    _.forEach(floorplans, function (floorplan) {
        if (floorplan.idLocation == id_floor) {
            retval = (floorplan.idParent == id_building)
        }
    })
    return retval

}

// everything is initialized to whatever is stored in cookies or a default value or null
// AWH TODO: make all of these be declared as property accessors using the keys
// AWH TODO: bring the explicitly declared items up into the body of INITIAL_STATE
// AWH TODO: sort the properties alphabetically

function getInitialState() {
    // get cookie values
    var cookie_buildnum = __cookies_get("buildnum", 0);
    if (cookie_buildnum != buildnum) {
        console.error("NEW BUILD DETECTED! CLEAR COOKIES!")
        __cookies_set_string("buildnum", buildnum)
    }

    var initial_id_floor = ts_temp__querystring_get_id_floor()
    var initial_id_building = ts_temp__querystring_get_id_building()

    var customer_name = ts_temp__querystring_get_customer_name();
    var id_segment = ts_temp__querystring_get_id_segment();
    var id_customer = ts_temp__querystring_get_id_customer();
    var api_token = ts_temp__querystring_get_api_token();
    var api_gateway = ts_temp__querystring_get_api_gateway();

    var site_code = ts_temp__querystring_get_site_code();


    var s = ts_temp__get_initial_state()

    // AWH remove me
    s.system_variables = {
        token: api_token,
        customerid: undefined,
        siteId: undefined,
        sitecode: site_code,
    }

    s = Immutable.fromJS(s);
    var EMPTY_ARRAY = Immutable.fromJS([]);
    var EMPTY_OBJECT = Immutable.fromJS({});



    s = setJSObject(s, KEY_ATTACHMENT_TYPE, "");
    s = setJSObject(s, KEY_ADD_ATTACHMENT_OBJECT, {});
    s = setJSObject(s, KEY_DATA_ASSETS, {});
    s = s.set(KEY_STATE_FIRST_RUN, true);
    s = s.set(KEY_DATA_FLOOR_ATTACHMENTS, EMPTY_OBJECT);
    s = s.set(KEY_DATA_ALL_ATTACHMENTS, EMPTY_OBJECT);
    s = s.set(KEY_DATA_PUSHPIN_COORDS, EMPTY_ARRAY);
    s = s.set(KEY_BUILDING_WO_COUNT, EMPTY_OBJECT);
    //    s = s.set(KEY_DATA_BUILDINGS, Immutable.fromJS([]));
    s = s.set(KEY_DATA_CATEGORIES, Immutable.fromJS({}));
    s = s.set(KEY_DATA_DRAWING_LOCATION_MAP, EMPTY_OBJECT) // lookup table mapping drawing_ids to id_locations and vice versa
    //    s = setJSObject(s, KEY_DATA_FLOORPLANS, []);
    s = setJSObject(s, KEY_DATA_SITEMAP, []);
    s = s.set(KEY_DATA_WORKORDERS, Immutable.fromJS([]));
    s = s.set(KEY_DEBUG_ENABLED, false);
    s = s.set(KEY_DOWNLOADED_ASSET_FLOORS, EMPTY_ARRAY);
    s = s.set(KEY_DOWNLOADED_ATTACHMENT_FLOORS, EMPTY_ARRAY);
    s = s.set(ts_temp__keys.ALLOW_3D_LINK_CREATE, null);

    s = setJSObject(s, KEY_DRAWING_P0, [0, 0]);
    var p1p2_cookie = __cookies_get_json(KEY_DRAWING_P1P2, [[null, null], [null, null]]);

    s = s.set(KEY_ID_DRAWING, null);   // these values should be initailly null.
    s = s.set(KEY_ID_FLOOR, null);      // once floorplan data starts arriving, we can set the floor
    s = s.set(KEY_ID_BUILDING, null);   // from floor history or from querystring values


    // awh todo: store the build number in a cookie. if the current buildnum and the buildnum in the cookie don't match, clear out all cookies.
    if (p1p2_cookie[0][0] == null) {
        // console.error("p1p2 is null. set id_drawing to null")
        // s= s.set(KEY_ID_DRAWING, null);
        // s=s.set(KEY_ID_FLOOR, null);
        // s=s.set(KEY_ID_BUILDING, null);
        s = setJSObject(s, KEY_FLOOR_DRAWING_HISTORY, []);
        // s = setJSObject(s, KEY_FLOOR_HISTORY, []);
    }
    s = s.set(KEY_DRAWING_P1P2, Immutable.fromJS(__cookies_get_json(KEY_DRAWING_P1P2, [[null, null], [null, null]])));


    s = s.set(KEY_MENU_ASSETS_CONTENT, Immutable.fromJS([]));// [{assetType:123, type:"fire_extinguisher", name:"Fire Extinguisher", count:8}...]
    s = s.set(KEY_MENU_ASSETS_SELECTED, Immutable.fromJS([]));// [asset_category 1, asset_category 2,...]   -- we do not remember selected assets
    //                                            -- across different buildings/floors
    s = setJSObject(s, KEY_MENU_ATTACHMENTS_CONTENT, { count: 0 });
    // s = s.set(KEY_MENU_ATTACHMENTS_SELECTED, false);
    s = s.set(KEY_MENU_PUSHPIN_SELECTED, false);
    s = s.set(KEY_MENU_BUILDINGS_CONTENT, Immutable.fromJS([]));// [{idLocation:123, sortOrder:0, name:"Empire State Bldg."}...]
    s = s.set(KEY_MENU_BUILDINGS_SHOW, true); // false if there is only one availible building in the building list





    //s = s.set(KEY_MENU_FLOORPLANS_CONTENT, Immutable.fromJS([]));//[{idLocation:123, sortOrder:0, name:"3rd floor", workorders:8}...]]
    s = s.set(KEY_MENU_WORKORDERS_CONTENT, Immutable.fromJS({}));// {cm_active: 8, cm_complete:12, ...} -- data is correct for current id_floor
    s = s.set(KEY_MENU_WORKORDERS_SELECTED, Immutable.fromJS([])); // [workorder_category_1, workorder_category_2,...]   -- we do not remember specific
    //                                                    -- selected workorders across
    //                                                    -- different buildings/floors
    // s = s.set(KEY_MENU_ATTACHMENTS_CONTENT, Immutable.fromJS({count:0}));
    s = s.set(KEY_MOUSE_CURSOR, "auto");
    s = s.set(KEY_STATE_ADD_ASSET, false);
    s = s.set(KEY_STATE_CREATING_ATTACHMENT, VALUE_CREATING_ATTACHMENT_VOID);
    s = setJSObject(s, KEY_ADD_ATTACHMENT_OBJECT, {});
    s = s.set(KEY_STATE_ADD_WORKORDER, false);
    s = s.set(KEY_STATE_FETCHING_ASSETS, false);
    s = s.set(KEY_STATE_FETCHING_ATTACHMENTS, false);
    s = s.set(KEY_STATE_ADD_FINDING, false);

    s = s.set(KEY_STATE_FETCHING_BUILDINGS, false);
    s = s.set(KEY_STATE_FETCHING_CATEGORIES, false);
    s = s.set(KEY_STATE_FETCHING_FLOORPLANS, false);
    s = s.set(KEY_STATE_FETCHING_SITEMAP_DATA, false);
    s = s.set(KEY_STATE_FETCHING_WORKORDERS, false);
    s = s.set(KEY_STATE_FETCHING_FINDINGS, false);
    s = s.set(KEY_STATE_PRINTING_FINDINGS, false);

    s = s.set(KEY_HARD_CODED_MAP, false);
    s = s.set(KEY_HARD_CODED_MAP_URL, "");
    s = s.set(KEY_WORKORDERS_QUERY, null);

    s = s.set(KEY_INITIAL_ID_BUILDING, initial_id_building);
    s = s.set(KEY_INITIAL_ID_FLOOR, initial_id_floor);


    return s;
}



/**
 *
 * @param source_point - an [x,y] point to translate
 * @param source_p1p2 - a two point georeference [[p1x,p1y],[p2x,p2y]] that the source point is coded to
 * @param target_p1p2 - a two point georeference [[p1x,p1y],[p2x,p2y]] that the source point till be translated into
 * @param p0 - a default point in case the source_point is null
 * @returns {{coords: [x,y], p1p2: [[p1x,p1y],[p2x,p2y]] }}  returns the translated point, and the p1p2 that this new point inhabits
 * @private
 */
// translate the source point into the target p1/p2. this also hnldes bad data cases (missing source or destiation
function __translateAndFixCoordinate(source_point, source_p1p2, target_p1p2, p0, tag) {



    if (source_point == null) {
        target_point = p0
        target_p1p2 = target_p1p2
    }
    else if (target_p1p2[0][0] == null) {
        // The target p1p2 is not set. Use the source coords and p1/p2
        console.error("drawing_p1p2 is not set")
        target_p1p2 = source_p1p2
        target_point = source_point
    }
    else if (source_p1p2[0][0] == null) {
        if (!tag) {
            tag = "";
        }
        console.error("feature p1p2 is not set - " + tag)
        // if the feature has no p1/p2 (i.e. the source p1p2 are null),
        // use the raw coords from the feature
        // and the p1p2 of the drawing
        // do not translate
        target_point = source_point
    }
    else {
        // we have a valid feature and drawing p1/p2. perform the translation
        //target_point = translate(source_point, source_p1p2, target_p1p2)

        target_point = geometry__js_translate(
            source_point[0],
            source_point[1],
            source_p1p2[0][0],
            source_p1p2[0][1],
            source_p1p2[1][0],
            source_p1p2[1][1],
            target_p1p2[0][0],
            target_p1p2[0][1],
            target_p1p2[1][0],
            target_p1p2[1][1])

        //target_point = [target_point., target_point.y]
    }

    return {
        coords: target_point,
        p1p2: target_p1p2
    }
}




/*****
 * updates the collection of attachments to reflect only the attachments for the current floor
 * the floor attachments is updated when either:
 *  1. the floor changes
 *  2. the underlying attachments data changes
 */
function __update_floor_attachments(imm_old_state, imm_new_state) {

    // update the attachments menu if necessary
    var update = didValueChange(imm_new_state, imm_old_state, KEY_ID_FLOOR)
    update |= didValueChange(imm_new_state, imm_old_state, KEY_DATA_ALL_ATTACHMENTS)

    if (update) {
        var floor_attachments = {}
        var id_floor = getIntOrNull(imm_new_state, KEY_ID_FLOOR);
        if (id_floor !== null) {
            floor_attachments = getJSObject(imm_new_state, KEY_DATA_ALL_ATTACHMENTS, {})[id_floor];
            if (floor_attachments === undefined) {
                floor_attachments = {}
            }
        }
        imm_new_state = setJSObject(imm_new_state, KEY_DATA_FLOOR_ATTACHMENTS, floor_attachments)
    }
    return imm_new_state;
}

/**
 * 
 *  */
function __update_menu_attachments(imm_old_state, imm_new_state) {
    if (didValueChange(imm_new_state, imm_old_state, KEY_DATA_FLOOR_ATTACHMENTS)) {
        var attachments = getJSObject(imm_new_state, KEY_DATA_FLOOR_ATTACHMENTS);
        var menu_attachments_content = datastore_menu__build_menu_content(attachments);
        imm_new_state = setJSObject(imm_new_state, KEY_MENU_ATTACHMENTS_CONTENT, menu_attachments_content)
    }

    return imm_new_state;
}


/**
 * Get the item from data_floorplans that matches the requested id_drawing. 
 * Item is returned as a JS Object, not an immutable
 * return null if not found
 **/
function __get_data_for_drawing(id_drawing, imm_state) {
    return ts_temp__get_data_for_drawing(id_drawing, imm_state)
}

// // returns an id_drawing or null
// function __get_a_default_id_drawing(imm_state, id_floor) {
//     ts_temp__get_a_default_drawing(id_floor, imm_state)
// }

/**
 * Updates the state to show a new floorplan drawing.
 * No attempt will be made to recover from bad input.
 * @param imm_old_state - the old state of the system (immutable)
 * @param id_floor - the new floor that is being set
 * @param id_drawing - the new drawing that is being set
 * @returns {immutable new state} an updated new state
 * @private
 */

function _actionSetFloorAndDrawing(imm_old_state, id_floor, id_drawing) {
    imm_new_state = imm_old_state

    drawing_info = __get_data_for_drawing(id_drawing, imm_old_state)

    p0 = drawing_info[KEY_P0]
    p1p2 = [drawing_info[KEY_P1], drawing_info[KEY_P2]]

    imm_new_state = setJSObject(imm_new_state, KEY_DRAWING_P0, p0)
    imm_new_state = setJSObject(imm_new_state, KEY_DRAWING_P1P2, p1p2)
    imm_new_state = imm_new_state.set(KEY_ID_FLOOR, id_floor)
    imm_new_state = imm_new_state.set(KEY_ID_DRAWING, id_drawing)

    __cookies_set_json(KEY_DRAWING_P0, p0);
    __cookies_set_json(KEY_DRAWING_P1P2, p1p2);
    __cookies_set_string(KEY_ID_FLOOR, id_floor);
    __cookies_set_string(KEY_ID_DRAWING, id_drawing);

    return imm_new_state
}

function getRawWorkorder(id_workorder) {
    return __sorted_raw_workorders[id_workorder]
}

function getRawAsset(id_asset) {
    return __sorted_raw_assets[id_asset]
}

        // coord = clean_up_coord([asset.xCoord, asset.yCoord])  // returns a valid coordinate or null
        // p1 = clean_up_coord([asset.p1xCoord, asset.p1yCoord])
        // p2 = clean_up_coord([asset.p2xCoord, asset.p2yCoord])
        // if (p1 == null)
        // {
        //     p1=[null,null]
        // }
        // if (p2 == null)
        // {
        //     p2=[null,null]
        // }


/**
 * This takes in a raw_workorders object from the api, and returns a cleaned up list
 * of workorders
 * @param raw_workorders
 * @private
 */
function _cleanup_workorders_data(raw_workorders) {  // This is an ECT (Extract, clean, transform) function - move it to a stand alone ECT js file
    var workorders = raw_workorders.workOrders;
    var data_workorders = [];

    _.forEach(workorders, function (raw_workorder) {
        var cleaned_workorder = ts_temp__cleanup_workorders_data(raw_workorder)
        if (cleaned_workorder !== null) {
            data_workorders.push(cleaned_workorder)
        }

        data_assets[id_floor].push({
            idCategory: id_category,
            icon: icon,
            assetNumber: assetNumber,
            xCoord: asset.xCoord,
            yCoord: asset.yCoord,
            adjCoords:coord,
            adjP1P2:[p1,p2],
            rawCoords:coord,
            rawP1P2:[p1,p2],
            idAsset:idAsset,
        })
    })
    return data_workorders;
}// end function _cleanup_workorders_data

/**
 *
 * @param old_state
 * @param new_state
 * @param raw_workorders
 * @returns updated imm_state
 * @private
 */
function _actionSetWorkordersData(imm_old_state, raw_workorders) {

    __sorted_raw_workorders = {} // may not be necessary TODO is this even used anywhere?
    _.forEach(raw_workorders.workOrders, function (workorder) {
        id_workorder = workorder.id
        __sorted_raw_workorders[id_workorder] = jQuery.extend({}, workorder)

    });

    return imm_old_state.set(KEY_DATA_WORKORDERS, Immutable.fromJS(_cleanup_workorders_data(raw_workorders)));
}

// Call this after any changes have been made to data_workorders. Returns an updated new_state.
// Consider removing this entirely and only generating the data_workorders_sorted list as it's needed.
function __update_workorders_sorted(imm_old_state, imm_new_state) {
    if (!imm_new_state.get(KEY_DATA_WORKORDERS).equals(imm_old_state.get(KEY_DATA_WORKORDERS))) {
        data_workorders_sorted = {}

        workorders = imm_new_state.get(KEY_DATA_WORKORDERS).toJS()

        _.forEach(workorders, function (workorder) {
            id_floor = workorder.idFloor
            if (data_workorders_sorted[id_floor] === undefined) {
                data_workorders_sorted[id_floor] = []
            }
            data_workorders_sorted[id_floor].push(workorder)
        })
        imm_new_state = imm_new_state.set("data_workorders_sorted", Immutable.fromJS(data_workorders_sorted))
    }
    return imm_new_state
}

// This reducer applies the first layer of changes - usually just applying the data based on
// the action. There is a second pass reducer that makes changes based on what this reducer changes.
function reducer_apply_action(imm_old_state, action, data) {

    switch (action) {

        case ACTION_SET_ADD_ATTACHMENT_OBJECT:
            {
                return setJSObject(imm_old_state, KEY_ADD_ATTACHMENT_OBJECT, data);
            }

        case ACTION_API_CREATEATTACHMENT_FAIL:
            {
                var new_state = imm_old_state;
                new_state = setJSBool(new_state, KEY_STATE_API_CREATEATTACHMENT, false);
                // behaves exactly like ACTION_API_CREATEATTACHMENT_SUCCESS
                return reducer_apply_action(new_state, ACTION_API_CREATEATTACHMENT_SUCCESS, data);
            }
        case ACTION_API_CREATEATTACHMENT_START:
            {
                var new_state = imm_old_state;
                new_state = setJSBool(new_state, KEY_STATE_API_CREATEATTACHMENT, true);
                // set the add attachment state to "API_CREATING_ATTACHMENT"
                return reducer_apply_action(new_state, ACTION_SET_ADD_ATTACHMENT_STATE, ts_temp__state_values.STATE_CREATING_ATTACHMENT_API_BUSY);
            }

        case ACTION_ADD_FETCHED_ATTACHMENTS_FLOOR:
            {
                attachment_floors = imm_old_state.get(KEY_DOWNLOADED_ATTACHMENT_FLOORS).toJS()
                attachment_floors.push(String(data));
                return imm_old_state.set(KEY_DOWNLOADED_ATTACHMENT_FLOORS, Immutable.fromJS(attachment_floors))
            }




        case ACTION_ADD_FETCHED_ASSETS_FLOOR:
            asset_floors = imm_old_state.get(KEY_DOWNLOADED_ASSET_FLOORS).toJS()
            asset_floors.push(String(data));
            return imm_old_state.set(KEY_DOWNLOADED_ASSET_FLOORS, Immutable.fromJS(asset_floors))


        case ACTION_CLEAR_ASSETS_DATA:
            new_state = imm_old_state
            new_state = new_state.set(KEY_DOWNLOADED_ASSET_FLOORS, Immutable.fromJS([]))
            new_state = new_state.set(KEY_DATA_ASSETS, Immutable.fromJS({}))
            __raw_assets = {}
            __sorted_raw_assets = {}
            __sorted_raw_assets_new = {}
            return new_state

        case ACTION_SET_FLOORPLAN_DATA:
            // take raw floorplan data, clean it up, verify that all
            // necessary fields exist, and save it to the state
            var new_state = imm_old_state
            __raw_floorplans = data
            return ts_temp__action_set_floorplan_data(imm_old_state, data)


        case ACTION_SET_SITEMAP_DATA:
            if (data.length > 0) {
                fetchSiteMapData();
            }
            else{
                var new_state = imm_old_state;
                new_state = setJSBool(new_state, KEY_STATE_SITEMAP_AVAILABLE, false);
                return new_state;
            }
            return ts_temp__action_set_sitemap_data(imm_old_state, data);


        case ACTION_SET_DRAWINGS_INFO_DATA:
            return ts_temp__action_set_drawings_info_data(imm_old_state, data);

        case ACTION_SET_MENU_ASSETS_SELECTED:
            return ts_temp__reducer(imm_old_state, ACTION_SET_MENU_ASSETS_SELECTED, Immutable.fromJS(data))


        case ACTION_SET_MENU_PUSHPIN_SELECTED:
            return ts_temp__reducer(imm_old_state, ACTION_SET_MENU_PUSHPIN_SELECTED, data);
        case ACTION_SET_ID_BUILDING:
            return ts_temp__reducer(imm_old_state, action, data);

        case ACTION_SET_SYSTEM_VARIABLES: {  // this needs to go away
            new_state = imm_old_state
            _.forOwn(data, function (value, key) {
                new_state = new_state.setIn(["system_variables", key], value)
                new_state = new_state.set(key, value)
            });
            return new_state
        }

        case ACTION_SET_FETCHING_ASSETS:
            return imm_old_state.set(KEY_STATE_FETCHING_ASSETS, data)

        case ACTION_SET_FETCHING_ATTACHMENTS:
            return imm_old_state.set(KEY_STATE_FETCHING_ATTACHMENTS, data)

        case ACTION_SET_FETCHING_BUILDINGS:
            return imm_old_state.set(KEY_STATE_FETCHING_BUILDINGS, data)

        case ACTION_SET_FETCHING_CATEGORIES:
            return imm_old_state.set(KEY_STATE_FETCHING_CATEGORIES, data)

        case ACTION_SET_FETCHING_FLOORPLANS:
            return imm_old_state.set(KEY_STATE_FETCHING_FLOORPLANS, data)

        case ACTION_SET_FETCHING_SITEMAP_DATA:
            return imm_old_state.set(KEY_STATE_FETCHING_SITEMAP_DATA, data);

        case ACTION_SET_FETCHING_DRAWINGS_INFO:
            return imm_old_state.set(KEY_STATE_FETCHING_DRAWINGS_INFO, data);

        case ACTION_SET_FETCHING_WORKORDERS: {
            return imm_old_state.set(KEY_STATE_FETCHING_WORKORDERS, data)
        }
        case ACTION_SET_HARD_CODED_MAP:
            {
                return imm_old_state.set(KEY_HARD_CODED_MAP, data);
            }

        case ACTION_SET_HARD_CODED_MAP_URL:
            {
                return imm_old_state.set(KEY_HARD_CODED_MAP_URL, data);
            }



        // case ACTION_SET_FLOOR:
        //     /*
        //      expected action.data ==
        //      {
        //      floor_id_drawing : "9b5b8852-f985-445a-ba00-7df642edb43a",
        //      id_floor         : "81097"
        //      }
        //      */

        //     id_floor   = data.id_floor
        //     id_drawing = data.floor_id_drawing

        //     if (id_drawing == null)
        //     {
        //         id_drawing = __get_a_default_id_drawing(imm_old_state, id_floor)
        //     }
        //     return _actionSetFloorAndDrawing(imm_old_state,
        //         id_floor,
        //         id_drawing)

        case ACTION_SET_ADD_ASSET_STATE:
            var imm_new_state = imm_old_state
            in_set_asset_mode = (data === true)
            if (in_set_asset_mode) {
                // we cannot be in both the new asset and new workorder states simultaneously.
                // if we're currently in the set work order mode, exit it.
                imm_new_state = imm_new_state.set(KEY_STATE_ADD_WORKORDER, false);
                imm_new_state = imm_new_state.set(KEY_STATE_ADD_FINDING, false);
                imm_new_state = imm_new_state.set(KEY_STATE_CREATING_ATTACHMENT, VALUE_CREATING_ATTACHMENT_VOID);
                imm_new_state = imm_new_state.set(KEY_MOUSE_CURSOR, "crosshair");
            }
            else {
                imm_new_state = imm_new_state.set(KEY_MOUSE_CURSOR, "auto");
            }
            imm_new_state = imm_new_state.set(KEY_STATE_ADD_ASSET, in_set_asset_mode);
            return imm_new_state;

        // case ACTION_SET_WORKORDERS_QUERY:
        //     var workOrdersQuery = data.query;
        //     var imm_new_state = imm_old_state;
        //     imm_new_state = imm_new_state.set(KEY_WORKORDERS_QUERY, Immutable.fromJS(workOrdersQuery))
        //     // remove the workorders from the state.
        //     __raw_workorders = {}
        //     imm_new_state = _actionSetWorkordersData(imm_new_state, {})
        //     fetchWorkordersData(workOrdersQuery)//TODO shouldn't be done inside reducer
        //     return imm_new_state

        case ACTION_SET_ADD_WORKORDER_STATE:
            var imm_new_state = imm_old_state
            in_set_workorder_mode = (data === true)
            if (in_set_workorder_mode) {
                // we cannot be in both the new asset and new workorder states simultaneously.
                // if we're currently in the set asset mode, exit it.
                imm_new_state = imm_new_state.set(KEY_STATE_ADD_ASSET, false)
                imm_new_state = imm_new_state.set(KEY_STATE_ADD_FINDING, false);
                imm_new_state = imm_new_state.set(KEY_STATE_CREATING_ATTACHMENT, VALUE_CREATING_ATTACHMENT_VOID)
                imm_new_state = imm_new_state.set(KEY_MOUSE_CURSOR, "crosshair")
            }
            else {
                imm_new_state = imm_new_state.set(KEY_MOUSE_CURSOR, "auto")
            }
            imm_new_state = imm_new_state.set(KEY_STATE_ADD_WORKORDER, in_set_workorder_mode)
            return imm_new_state

        case ACTION_TOGGLE_DEBUG:
            {
                debug_enabled = data;
                //__cookies_set_bool(KEY_DEBUG_ENABLED, debug_enabled)  // set the cookie
                imm_new_state = imm_old_state
                return imm_new_state.set(KEY_DEBUG_ENABLED, debug_enabled)
            }

        case ACTION_UI_CREATEATTACHMENT_GET_COORD_START:
            {
                var new_state = imm_old_state;
                if (data) {
                    new_state = new_state.set(KEY_ATTACHMENT_TYPE, data);
                }
                // we cannot be in both the new asset and new workorder states simultaneously.
                // if we're currently in the set work order mode, exit it.
                new_state = new_state.set(KEY_STATE_ADD_WORKORDER, false)
                new_state = new_state.set(KEY_STATE_ADD_ASSET, false)
                new_state = setJSBool(new_state, ts_temp__keys.KEY_STATE_UI_CREATEPUSHPIN_GET_COORD, false);
                new_state = new_state.set(KEY_STATE_ADD_FINDING, false);
                new_state = new_state.set(KEY_MOUSE_CURSOR, "crosshair")

                // Reset the attachment object
                new_state = setJSObject(new_state, KEY_ADD_ATTACHMENT_OBJECT, {})
                new_state = setJSBool(new_state, KEY_STATE_UI_CREATEATTACHMENT_GET_COORD, true)
                return new_state;

            }
        case ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP:
            {
                var new_state = imm_old_state;
                new_state = new_state.set(KEY_MOUSE_CURSOR, "auto")
                new_state = new_state.set(KEY_ATTACHMENT_TYPE, "");
                new_state = setJSBool(new_state, KEY_STATE_UI_CREATEATTACHMENT_GET_COORD, false)
                return new_state;

            }
        case ACTION_SET_PUSHPIN_GET_COORD_START:
            {
                var new_state = imm_old_state;
                new_state = new_state.set(KEY_STATE_ADD_WORKORDER, false);
                new_state = new_state.set(KEY_STATE_ADD_ASSET, false);
                new_state = setJSBool(new_state, KEY_STATE_UI_CREATEATTACHMENT_GET_COORD, false);
                new_state = setJSBool(new_state, ts_temp__keys.KEY_STATE_UI_CREATEPUSHPIN_GET_COORD, true);
                new_state = new_state.set(KEY_MOUSE_CURSOR, "crosshair")
                return new_state;
            }
        case ACTION_SET_PUSHPIN_GET_COORD_STOP:
            {
                var new_state = imm_old_state;
                new_state = new_state.set(KEY_MOUSE_CURSOR, "auto");
                new_state = setJSBool(new_state, ts_temp__keys.KEY_STATE_UI_CREATEPUSHPIN_GET_COORD, false);
                return new_state;
            }
        case ACTION_SET_SITEMAP_URL:
            {
                var new_state = imm_old_state;
                new_state = setJSBool(new_state, KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP, data);
                return ts_temp__action_set_sitemap_url(imm_old_state, data)
            }
        case ACTION_SET_SITEMAP_AVAILABLE:
            {
                var new_state = imm_old_state;
                new_state = setJSBool(new_state, KEY_STATE_SITEMAP_AVAILABLE, data);
                return new_state;
            }
        case ACTION_SET_SITEMAP_GEOJSON:
            {
                var new_state = imm_old_state;
                new_state = setJSObject(new_state, KEY_SITEMAP_GEOJSON, data);

                return new_state;
            }
        // case ACTION_SET_SITEMAP_AS_CURRENT_PAGE:
        //     {
        //         var new_state = imm_old_state;
        //         new_state = setJSBool(new_state, KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP, data);
        //         return new_state;
        //     }
        case ACTION_SET_SITEMAP_ID_BUILDING:
            {
                var new_state = imm_old_state;
                new_state = setJSObject(new_state, KEY_SITEMAP_ID_BUILDING, data);
                return new_state;
            }
        default:
            {
                return ts_temp__reducer(imm_old_state, action, data)
            }
    }

    console.error("reducer() unhandled action. SHOULD NOT BE HERE!")
    return imm_old_state
} // end function reducer_apply_action

function simpleReducer(imm_old_state, action, data) {
    return cmsViewReducer(imm_old_state, { type: action, data: data })
}

/**
 *
 * @param category_lookup_table {id_category:{desc: "", parent_id: ""}...}
 * @param assets {id_asset:{asset}...}
 * @return menu_assets_content_new - the format example is: [{"idCategory":"6","label":"Electrical System","count":3,
 * "icon":"","menuItems":[{"label":"Variable Frequency Drive","idCategory":"77","count":1,"icon":""},
 * {"label":"Battery Powered","idCategory":"201","count":1,"icon":""},{"label":"Normal","idCategory":"384","count":1,
 * "icon":""}]},etc
 */
function build_menu_assets_content(category_lookup_table, assets) {
    menu_assets_content_new = []

    // organize the assets by category_id (actual assets grouped by category), keyed by category_id
    assets_by_category_id = {}

    //building the assets_by_category_id (the skeleton of the menu)
    _.forEach(assets, function (asset) {
        var id_category = asset.idCategory
        if (!(id_category in assets_by_category_id)) {
            assets_by_category_id[id_category] = []
        }
        assets_by_category_id[id_category].push(asset)
    })

    //lookup table of all root categories, keyed by category_id
    var root_categories = get_root_categories(category_lookup_table)

    // building the menu_assets with parents and children
    _.forOwn(assets_by_category_id, function (value, key) {
        var id_category = key
        var exists_in_category_lookup_table = _.has(category_lookup_table, id_category);
        var self_label = "";
        var parent_id = "";
        //getting the label and parent_id from category_lookup_table
        if (exists_in_category_lookup_table) {
            self_label = category_lookup_table[id_category].desc;
            parent_id = category_lookup_table[id_category].parent_id;
        }

        var parent = {};
        var parent_exists_in_menu_assets_content = _.findIndex(menu_assets_content_new, function (o) {
            return o.parent_id == parent_id;
        });

        if (parent_exists_in_menu_assets_content == -1) {
            var parent_label = "";
            if (_.has(root_categories, parent_id)) {
                label = root_categories[parent_id];
            }
            parent = {
                parent_id: parent_id,
                label: label,
                count: value.length,
                icon: value[0].icon,
                menuItems: []
            };
            parent.menuItems.push({
                label: self_label,
                idCategory: id_category,
                count: value.length,
                icon: value[0].icon
            });
            menu_assets_content_new.push(parent);
        }
        else {
            parent = menu_assets_content_new[parent_exists_in_menu_assets_content];
            parent.menuItems.push({
                label: self_label,
                idCategory: id_category,
                count: value.length,
                icon: value[0].icon
            });
            parent.count += value.length;
        }


    }); //end _.forOwn
    // sorting the menuItems for each parent category
    var menu_assets_w_sorted_menuItems = _.forEach(menu_assets_content_new, function (value, key) {
        value.menuItems = _.sortBy(value.menuItems, function (asset) {
            return asset.label;
        });
    });

    // sorting the parent categories
    var sorted_menu_assets_content = _.sortBy(menu_assets_w_sorted_menuItems, [function (category) {
        return category.label;
    }]);
    return sorted_menu_assets_content;
} // end function build_menu_assets_content

/**
 * Method returns the parent categories object in the following format {parent_id, desc}
 * @param category_lookup_table
 * @return root_categories {{}}
 */
function get_root_categories(category_lookup_table) {
    var root_categories = {};
    _.forOwn(category_lookup_table, function (value, key) {
        id = key;
        var parent = value.parent_id;
        if (id == parent) {
            root_categories[id] = value.desc;
        }
    })
    return root_categories;
} //end function get_root_categories

function cmsViewReducer(imm_old_state, dispatched_action) {
    // simple reducer
    var imm_new_state = reducer_apply_action(imm_old_state, dispatched_action.type, dispatched_action.data)


    // //    var dl_map = getJSObject(imm_new_state, KEY_DATA_DRAWING_LOCATION_MAP, {})
    // if (Object.keys(getJSObject(imm_new_state, KEY_DATA_DRAWING_LOCATION_MAP, [])).length == 0) {
    //     // The drawing<->location map doesn't exist yet.
    //     // Don't try to guess a drawing.
    // }
    // else {
    //     var id_floor = imm_new_state.get(KEY_ID_FLOOR);
    //     var id_building = imm_new_state.get(KEY_ID_BUILDING);
    //     if (!__isFloorInBuilding(id_floor, id_building, imm_new_state)) {


    //         // awh todo: isolate this into a "get floor from building" function
    //         // look in the history for a drawing from this building
    //         var floor_drawing_history = getJSArray(imm_new_state, KEY_FLOOR_DRAWING_HISTORY, []);
    //         _.forEach(floor_drawing_history, function (id_drawing) {
    //             id_location = imm_new_state.get(KEY_DATA_DRAWING_LOCATION_MAP).get(id_drawing)
    //             if (__isFloorInBuilding(id_location, id_building, imm_new_state)) {
    //                 imm_new_state = _actionSetFloorAndDrawing(imm_new_state, id_floor, id_drawing);
    //                 return
    //             }
    //         })
    //         // if that failed, search all the floorplans
    //         if (!__isFloorInBuilding(id_floor, id_building, imm_new_state)) {
    //             var data_floorplans = getJSArray(imm_new_state, KEY_DATA_FLOORPLANS, []);
    //             _.forEach(data_floorplans, function (floorplan) {
    //                 if (floorplan.id_building == id_building) {
    //                     var id_floor = floorplan.id_floor;
    //                     var floor_id_drawing = floorplan.id_drawing;
    //                     imm_new_state = _actionSetFloorAndDrawing(imm_new_state, id_floor, floor_id_drawing);
    //                     return
    //                 }
    //             })
    //         }
    //     }
    // }
    if (did_any_value_change(imm_new_state, imm_old_state, [KEY_DATA_WORKORDERS, KEY_ID_FLOOR])) {
        // awh todo move this to TS
        imm_new_state = ts_temp__update_menu_workorders_content(imm_new_state)
    }


    if (did_value_change(imm_old_state, imm_new_state, KEY_ID_DRAWING)) // if the id_drawing changed, backup the old id_drawing
    {
        // AWH todo move to TS
        var old_id_drawing = imm_old_state.get(KEY_ID_DRAWING)
        var new_id_drawing = imm_new_state.get(KEY_ID_DRAWING)

        var old_id_floor = imm_old_state.get(KEY_ID_FLOOR)
        var new_id_floor = imm_new_state.get(KEY_ID_FLOOR)

        if (old_id_drawing != null) {
            var new_state = imm_new_state.toJS();  // awh todo refactor this away // this is INSANELY expensive. avoid toJS() on the state
            const FLOOR_HISTORY_LENGTH = 100
            // Keep a limited history. History is useful for determining what drawing to diaplay
            // when reloading the page or switching buildings.
            // Keep a finite history of floors.

            // new_state.floor_history.push([old_id_floor, old_id_drawing])
            //
            // while (new_state.floor_history.length > FLOOR_HISTORY_LENGTH) {
            //     new_state.floor_history.pop()
            // }
            // __cookies_set_json(KEY_FLOOR_HISTORY, new_state.floor_history)

            // awh todo: delete these lines
            new_state.floor_drawing_history.push(old_id_drawing)
            while (new_state.floor_drawing_history.length > FLOOR_HISTORY_LENGTH) {
                new_state.floor_drawing_history.shift(); //removes from front of array
            }
            __cookies_set_json("floor_drawing_history", new_state.floor_drawing_history)
            imm_new_state = Immutable.fromJS(new_state)
        }
    }

    imm_new_state = __update_floor_attachments(imm_old_state, imm_new_state)
    imm_new_state = __update_menu_attachments(imm_old_state, imm_new_state)
    imm_new_state = __update_workorders_sorted(imm_old_state, imm_new_state)

    imm_new_state = imm_new_state.set(KEY_STATE_FIRST_RUN, false);

    return ts_temp__reducer_2(imm_old_state, imm_new_state);
} // end function cmsViewReducer



/**
 * gets the integer representation of the value at KEY or returns null 
 */
function getIntOrNull(imm_state, key) {
    var ret_val = parseInt(imm_state.get(key));
    var bad = isNaN(ret_val)
    if (bad) {
        return null
    }
    return ret_val;

}
function getInt(imm_state, key, default_value) {
    if ((default_value === undefined) || (default_value === null)) {
        default_value = 0;
    }
    ret_val = getIntOrNull(imm_state, key)
    if (ret_val === NaN) {
        rat_val = default_value
    }
    return ret_val;
}

function getJSObjectOrNull(imm_state, key) {
    var ret_val = imm_state.get(key);
    if ((ret_val === undefined) | (ret_val === null)) {
        return null
    }
    return ret_val.toJS();
}
/**
 * Gets an object from an immutable object. The object will be returned as a javascript object, not an immutable.
 * If the item at the key is not an array, null, missing, a string or integer, then jetJS Object will return the default value instead.
 * if default value is missing default will be an empty object {}
 **/
function getJSObject(imm_state, key, default_value) {
    var ret_val = imm_state.get(key);
    if ((default_value === undefined) || (default_value === null)) {
        default_value = {};
    }
    if ((ret_val === undefined) | (ret_val === null)) {
        return default_value
    }

    if (typeof ret_val.toJS !== 'function') {
        console.error("getJSObject(" + key + ") -> " + ret_val)
    }
    return ret_val.toJS();
}
/**
 * sets the object as an immutable object witin the parent imutable object 
 * */
function setJSObject(imm_state, key, obj) {
    return imm_state.set(key, Immutable.fromJS(obj))
}
function setJSBool(imm_state, key, val) {
    if (typeof (val) === typeof (true)) {
        return imm_state.set(key, val);
    }
    if (typeof (val) === typeof ("")) {
        return setJSBool(imm_state, key, val.toLowerCase() === "true");
    }
    console.error("setJSBool(" + val + ") is undefined.")
    return imm_state.set(key, false)
}

export function getJSArray(imm_state, key, default_value) {
    return ts_temp__get_js_array(imm_state, key, default_value)
}

export function getJSBool(imm_state, key, default_value) {
    var ret = imm_state.get(key);
    if (typeof (ret) === typeof (true)) {
        return ret
    }
    if (typeof (default_value) === typeof (true)) {
        default_value = false
    }
    return default_value;
}

export function previous_state() {
    return __datastore.previous_state;
}

export function immutable_state() {
    return __datastore.immstate;
}

export function immState() {
    return __datastore.immstate;
}


/**
 * Dispatch() is the first stage of the Dispatch -> reduce -> update -> notify opattern of Redux
 * actions and data are Dispatched, which returns immediately. Dispatch then 
 * calls the reducer whgich applies the actions to the state, and then all 
 * subscribers are notified that the state has changed.
 */
export function dispatch(action, data) {
    var action_obj = { type: action, data: data };
    // dispatch is asynchronous
    setTimeout(function () {
        __datastore.previous_state = __datastore.immstate;
        __datastore.immstate = cmsViewReducer(__datastore.immstate, action_obj);
        __datastore.state = null;
        notifySubscribers()
    }, 2)
}

/**
 * dispatchBatch() Works exactly like dispatch except it dispatches multiple
 * actions and notifies subscribers once. The actions are applied in the same 
 * order as they exist in the arraay.
 * actions: array of arrays containing actions and data:
 *          [[action1, data1],[action2, data2],[action3, data3]]
 * */
export function dispatchBatch(actions) {
    // dispatch is asynchronous
    setTimeout(function () {
        var previous_state = __datastore.immstate;  // get the previous state before the batch processing

        _.forEach(actions, function (action_data) {
            let action = action_data[0]
            let data = action_data[1]
            __datastore.immstate = simpleReducer(__datastore.immstate, action, data)
            __datastore.state = null
        })
        __datastore.previous_state = previous_state

        notifySubscribers()
    }, 2)
}

/**
 * This should take raw data_categories and create an object that
 * contains {id:{desc: "", parent_id: ""}...}
 * @param data_categories_raw
 * @returns {{}}
 */
// function make_modified_category_objects(data_categories_raw) {
//     var root_categories = {};
//     _.forEach(data_categories_raw.data, function (category) {
//         //var temp = {desc: category.desc, parent: };
//         var temp = {};
//         if (category.level == 0) {
//             //root_categories[category.id] = category.desc;
//             temp = { desc: category.desc, parent_id: category.id };
//         }
//         else {
//             temp = { desc: category.desc, parent_id: _.head(_.tail(category.hierarchy.split("."))) };
//         }
//         root_categories[category.id] = temp;
//     })
//     return root_categories;
// }//end function make_modified_category_objects

function notifySubscribers() {
    _.forEach(__datastore.listeners,
        function (listener) {
            listener()
        })
}

function getMapWorkordersContent(id_location, workorder_type) {
    console.error("getMapWorkordersContent")
}

export function getState() {
    return immState().toJS();
}

export function getImmState() { return __datastore.immstate }

export function subscribe(listener) {
    __datastore.listeners.push(listener)
}


function dispatchSystemVariable(variable, value) {
    // awh todo - break this up into multiple single dispatches
    console.error("dispatchSystemVariable(" + variable + ", " + value + ")")
    system_variables = getState().system_variables
    system_variables[variable] = value
    //    Cookies.set(variable, value)
    __cookies_set_string(variable, value)

    dispatch(ACTION_SET_SYSTEM_VARIABLES, system_variables)
}

function dispatchUiVariable(param, value) {
    // warning - this will not do any follow-on validation of the state.
    __datastore.previous_state = __datastore.immstate;
    __datastore.immstate = __datastore.immstate.set(param, value) // , action)
    __datastore.state = null
    notifySubscribers()

}

export function dispatchFloorplanVariables(id_location, id_drawing) {
    //    new_state=getState()
    // new_state.floor_id_drawing=id_drawing
    // new_state.id_floor=id_location
    // __cookies_set_string(KEY_ID_DRAWING, id_drawing)
    // __cookies_set_string(KEY_ID_FLOOR, id_location)
    dispatch(ts_temp__actions.ACTION_SET_FLOOR, { id_floor: id_location, id_drawing: id_drawing })
}

function dispatchWorkorderSelected(workorder_type, isSelected) {
    var selected_workorders = immState().get(KEY_MENU_WORKORDERS_SELECTED).toJS();
    if (isSelected) {
        selected_workorders.push(workorder_type);
    }
    else {
        _.pull(selected_workorders, workorder_type);
    }
    dispatch(ACTION_SET_MENU_WORKORDERS_SELECTED, selected_workorders)
}


function dispatchAssetSelected(id_category, isSelected) {
    var selected_assets = immState().get(KEY_MENU_ASSETS_SELECTED).toJS();
    if (isSelected) {
        selected_assets.push(id_category);
    }
    else {
        _.pull(selected_assets, id_category);
    }
    dispatch(ACTION_SET_MENU_ASSETS_SELECTED, selected_assets)
}

function dispatchToggleAllAssets(toggle_on) {
    var selected_assets = [];
    if (toggle_on) {
        // add all categories to the selected categories list
        var all_categories = immState().get(KEY_DATA_CATEGORIES).toJS();
        selected_assets = Object.keys(all_categories);
    }
    dispatch(ACTION_SET_MENU_ASSETS_SELECTED, selected_assets);
}


function dispatchToggleAllWorkorders(toggle_on) {
    var selected_workorders = [];
    if (toggle_on) {

        var all_workorders = immState().get(KEY_DATA_WORKORDERS).toJS();
        _.forEach(all_workorders, function (workorder) {
            selected_workorders.push(workorder.type)
        })
        selected_workorders = _.uniq(selected_workorders);
    }
    dispatch(ACTION_SET_MENU_WORKORDERS_SELECTED, selected_workorders)
}

// for debugging use only
function debug_setHardCodedMapUrl(map_url) {
    dispatchBatch([[ACTION_SET_HARD_CODED_MAP, true], [ACTION_SET_HARD_CODED_MAP_URL, map_url]]);
}

function debug_unsetHardCodedMapUrl() {
    dispatchBatch([[ACTION_SET_HARD_CODED_MAP, false], [ACTION_SET_HARD_CODED_MAP_URL, ""]]);
}

function toggleDebug(toggle_on) {
    if (typeof (toggle_on) != typeof (true)) {
        toggle_on = !immState().get(KEY_DEBUG_ENABLED)
    }
    dispatch(ACTION_TOGGLE_DEBUG, toggle_on)
}





// WEBPACK FOOTER //
// ./js/cms_view_datastore.js